<template>
  <div
    class="support-merchant-page d-flex align-items-center justify-content-center min-vh-100 bg-light p-3"
  >
    <div
      v-if="step === 1"
      class="form-container bg-white p-4 shadow-sm rounded w-100"
      style="max-width: 500px"
    >
      <h2 class="text-center mb-4 font-weight-bold">Yêu cầu hỗ trợ</h2>

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <!-- Thông tin liên hệ -->
          <validation-provider
            rules="required|emailOrPhone"
            name="Thông tin liên hệ"
            v-slot="{ errors }"
          >
            <div class="form-group mb-3">
              <label for="infoContact" class="font-weight-600"
                >Thông tin liên hệ <span class="text-danger">*</span></label
              >
              <input
                id="infoContact"
                v-model="infoContact"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.length > 0 }"
                placeholder="Email hoặc số điện thoại"
              />
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </div>
          </validation-provider>

          <!-- Yêu cầu -->
          <validation-provider name="Ghi chú" v-slot="{ errors }">
            <div class="form-group mb-4">
              <label for="note" class="font-weight-600">Ghi chú</label>
              <textarea
                id="note"
                v-model="note"
                rows="8"
                class="form-control"
                :class="{ 'is-invalid': errors.length > 0 }"
                placeholder="Nhập ghi chú"
              ></textarea>
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </div>
          </validation-provider>

          <!-- Submit Button -->
          <div class="form-group mb-0">
            <button
              type="submit"
              class="btn btn-primary btn-block py-2 font-weight-bold"
              :disabled="isLoading"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                aria-hidden="true"
              ></span>
              Gửi yêu cầu
            </button>
          </div>
        </form>
      </validation-observer>
    </div>
    <div
      v-else
      class="form-container bg-white p-4 shadow-sm rounded w-100"
      style="max-width: 500px"
    >
      <div class="mb-4">
        <i class="fa fa-check-circle text-success" style="font-size: 4rem"></i>
      </div>
      <h4 class="mb-3 font-weight-bold text-center">Gửi thông tin thành công</h4>
      <p class="text-muted mb-4 text-center">
        Chúng tôi đã nhận được yêu cầu của bạn và sẽ phản hồi trong thời gian sớm nhất.
      </p>
      <!-- <button class="btn btn-success btn-block py-2 font-weight-bold">Chấp nhận</button> -->
    </div>
  </div>
</template>

<script>
  import { updateTaskSupportCustomer } from '@/services/customer-support/task'
  import md5 from 'md5'
  import { v4 as uuidv4 } from 'uuid'
  import { showMess } from '@/config/utils'

  const CHECKSUM_KEY =
    window._env_?.VUE_APP_CUSTOMER_SUPPORT_TOKEN ?? process.env.VUE_APP_CUSTOMER_SUPPORT_TOKEN

  export default {
    name: 'SupportMerchant',
    data() {
      return {
        step: 1,
        isLoading: false,
        taskId: '',
        infoContact: '',
        note: '',
      }
    },
    created() {
      this.taskId = this.$route.query.taskId
    },
    methods: {
      async submit() {
        if (!this.taskId) {
          showMess(
            this,
            'Thông báo',
            'Không tìm thấy ID yêu cầu',
            'warning',
            'b-toaster-top-right',
            3000
          )
          return
        }

        try {
          this.isLoading = true
          const requestId = uuidv4()
          console.log(this.taskId + requestId + CHECKSUM_KEY)
          const checksum = md5(this.taskId + requestId + CHECKSUM_KEY)
          const body = {
            taskId: this.taskId,
            infoContact: this.infoContact.trim(),
            note: this.note.trim(),
            requestId,
            checksum,
          }

          const res = await updateTaskSupportCustomer(body)
          if (res.code === 1000) {
            this.step = 2
          } else {
            showMess(
              this,
              'Lỗi',
              res.message || 'Có lỗi xảy ra khi gửi yêu cầu',
              'danger',
              'b-toaster-top-right',
              3000
            )
          }
        } catch (err) {
          showMess(
            this,
            'Lỗi',
            err.response?.data?.message || err.response?.message || err.message || 'Có lỗi xảy ra',
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .support-merchant-page {
    background-color: #f8f9fa;

    .font-weight-600 {
      font-weight: 600;
    }

    .form-container {
      border-radius: 12px;
      border: none;
      transition: transform 0.3s ease;

      @media (max-width: 576px) {
        padding: 1.5rem !important;
      }
    }
  }
</style>
